import React, { useEffect, useState } from "react";

/**
 * Founder card + "Also from Pravadh Labs" promo for the login and sign-up
 * left panel. The promo rotates through the other Pravadh products; each
 * site shows the previous product in the chain first (IQ on GovernX,
 * GovernX on PM, PM on SI, SI on Caliber) and never advertises itself.
 * Same component ships in PravadhIQ, GovernX, Pravadh SI and Caliber.
 */
const PRODUCTS = {
  IQ: { name: "PravadhIQ", tagline: "Ship it. Prove it.", line: "Salesforce DevOps and data migration on one SHA-256 audit chain.", host: "pravadhiq.pravadhlabs.com", color: "#2563eb" },
  GX: { name: "Pravadh GovernX", tagline: "Connect. Clean. Govern.", line: "Salesforce, Zoho and Oracle data in one governed layer.", host: "pravadhgx.pravadhlabs.com", color: "#0d9488" },
  PM: { name: "Pravadh PM", tagline: "Don’t track it. Ship it.", line: "Tracker, service desk and an AI crew that builds each story.", host: "pravadhpm.pravadhlabs.com", color: "#4f46e5" },
  SI: { name: "Pravadh SI", tagline: "Right buyer. Right moment.", line: "AI prospecting and outreach. Nothing sends until you approve.", host: "pravadhsi.pravadhlabs.com", color: "#ea580c" },
  CB: { name: "Caliber", tagline: "Every candidate, heard.", line: "AI first-round voice interviews, scored and sealed.", host: "caliberai.pravadhlabs.com", color: "#9333ea" },
  DS: { name: "Pravadh DocSign", tagline: "Generate. Sign. Done.", line: "Free document generation and eSignature inside Salesforce.", host: "pravadhdocsign.pravadhlabs.com", color: "#0891b2" },
};

const ORDER = {
  IQ: ["DS", "GX", "PM", "SI", "CB"],
  GX: ["IQ", "PM", "SI", "CB", "DS"],
  PM: ["GX", "SI", "CB", "DS", "IQ"],
  SI: ["PM", "CB", "DS", "IQ", "GX"],
  CB: ["SI", "DS", "IQ", "GX", "PM"],
};

const card = { border: "1px solid #243556", borderRadius: 14, background: "#101C36" };
const mono = { fontFamily: "'JetBrains Mono', ui-monospace, monospace" };

export default function FounderPromo({ site, photo = "/founder-dhairya-shah.jpg", interval = 5000, page = "login" }) {
  const order = ORDER[site] || ORDER.IQ;
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return undefined;
    const t = setInterval(() => setI((n) => (n + 1) % order.length), interval);
    return () => clearInterval(t);
  }, [paused, order.length, interval]);

  const p = PRODUCTS[order[i]];
  const href = `https://${p.host}/?utm_source=${site.toLowerCase()}&utm_medium=${page}&utm_campaign=cross_promo`;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20, color: "#EAF3FF" }} data-testid="founder-promo">
      <div style={{ ...card, display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", gap: 12, padding: "22px 18px" }}>
        <img src={photo} alt="Dhairya Shah" width={88} height={88}
          style={{ width: 88, height: 88, borderRadius: "50%", objectFit: "cover", border: "2px solid #243556" }} />
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
          <span style={{ fontSize: 17, fontWeight: 600, color: "#FFFFFF" }}>Dhairya Shah</span>
          <span style={{ fontSize: 13, color: "#A9B8D0" }}>Founder &amp; CEO, Pravadh Labs</span>
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}
        onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}
        onFocus={() => setPaused(true)} onBlur={() => setPaused(false)}>
        <span style={{ ...mono, fontSize: 11, letterSpacing: "0.12em", color: "#8FB4FF" }}>ALSO FROM PRAVADH LABS</span>
        <a href={href} target="_blank" rel="noopener noreferrer" data-testid="founder-promo-link"
          style={{ ...card, background: "#132447", borderColor: p.color, display: "flex", flexDirection: "column", gap: 7, padding: "16px 18px", textDecoration: "none" }}>
          <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span aria-hidden="true" style={{ width: 10, height: 10, borderRadius: "50%", background: p.color }} />
            <span style={{ fontSize: 17, fontWeight: 600, color: "#FFFFFF" }}>{p.name}</span>
          </span>
          <span style={{ fontSize: 15, color: "#FD9E01" }}>{p.tagline}</span>
          <span style={{ fontSize: 13.5, lineHeight: 1.45, color: "#C9D6EA" }}>{p.line}</span>
          <span style={{ fontSize: 13, fontWeight: 600, color: "#8FB4FF" }}>Visit {p.host} →</span>
        </a>
        <div style={{ display: "flex", gap: 6 }} aria-hidden="true">
          {order.map((k, n) => (
            <span key={k} style={{ width: 22, height: 4, borderRadius: 2, background: n === i ? "#FD9E01" : "#3d5278" }} />
          ))}
        </div>
      </div>
    </div>
  );
}
